const appReducer = (
  state = {
    loading: false,
    data: null,
  },
  action
) => {
  switch (action.type) {
    case "SET_APP_LOADING":
      return {
        ...state,
        loading: action.payload.loading,
      };

    case "SET_PERMISSIONS":
      return {
        ...state,
        data: { ...state.data, permissions: action.payload },
      };

    case "SET_TRACKING":
      return {
        ...state,
        data: { ...state.data, isTrackingEnabled: action.payload },
      };

    case "RESET_APP_DATA":
      return {
        loading: false,
        data: null,
      };

    default:
      return state;
  }
};
export default appReducer;
